export default {_name:'divider',module:'Card/Form',view:'Element/Divider',options:{variant:'fullWidth',orientation:'horizontal',flexItem:true}}